import { RadioGroup, RadioGroupProps } from '@billy/design-system'
import { ReactElement } from 'react'

export type RadioButtonSectionGroupProps = Omit<RadioGroupProps, 'disabled'>

export const RadioButtonSectionGroup = ({ children, ...rest }: RadioButtonSectionGroupProps): ReactElement => (
  <RadioGroup {...rest}>{children}</RadioGroup>
)
